import { ManufacturerDto } from '../dto'
import { ManufacturerModel } from '../models'
import { ManufacturerState } from '../types'

const MANUFACTURER_REQUIRED_FIELDS_SPLITTER = ','
const VIN_REQUIRED_STRING = 'VIN'

/**
 * transform fetched manufacturer to manufacturer model
 */
export const transformManufacturerDtoToModel = (dto: ManufacturerDto[]): ManufacturerModel[] => {
  return dto.map(manufacturer => ({
    name: manufacturer.name,
    id: manufacturer.vendor,
    logoUrl: manufacturer.logoUrl ?? '',
    vinNeeded: manufacturer.requiredFields?.split(MANUFACTURER_REQUIRED_FIELDS_SPLITTER).includes(VIN_REQUIRED_STRING) ?? false,
    state: manufacturer.state ?? ManufacturerState.available,
  }))
}
